export default "__VITE_ASSET__8k6_Ij9W__"